module.exports = __webpack_public_path__ + "static/img/thumbnails-grey.7251c16.png";